import { createContext } from "react";

export const WSContext = createContext(null);